export const dimensionFormConstants = {
  quant: { id: 'quant' as const, label: 'Quantity' },
  dimensionUnit: { id: 'dimensionUnit' as const, label: 'Unit' },
  dimensionValue: { id: 'dimensionValue' as const, label: 'Quantity' },
  dimensionClass: { id: 'dimensionClass' as const, label: 'Dimension Class' },
} as const;
